import { render, staticRenderFns } from "./CompanyStaffEditPage.vue?vue&type=template&id=e032f34e&"
import script from "./CompanyStaffEditPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyStaffEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports